import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentsSidebarCloseButton from './VeltCommentsSidebarCloseButton/VeltCommentsSidebarCloseButton';
import VeltCommentsSidebarEmptyPlaceholder from './VeltCommentsSidebarEmptyPlaceholder/VeltCommentsSidebarEmptyPlaceholder';
import VeltCommentsSidebarFilter from './VeltCommentsSidebarFilter/VeltCommentsSidebarFilter';
import VeltCommentsSidebarHeader from './VeltCommentsSidebarHeader/VeltCommentsSidebarHeader';
import VeltCommentsSidebarList from './VeltCommentsSidebarList/VeltCommentsSidebarList';
import VeltCommentsSidebarPageModeComposer from './VeltCommentsSidebarPageModeComposer/VeltCommentsSidebarPageModeComposer';
import VeltCommentsSidebarSearch from './VeltCommentsSidebarSearch/VeltCommentsSidebarSearch';
import VeltCommentsSidebarStatus from './VeltCommentsSidebarStatus/VeltCommentsSidebarStatus';
import VeltCommentsSidebarFilterButton from './VeltCommentsSidebarFilterButton/VeltCommentsSidebarFilterButton';
import VeltCommentsSidebarSkeleton from './VeltCommentsSidebarSkeleton/VeltCommentsSidebarSkeleton';
import VeltCommentsSidebarPanel from './VeltCommentsSidebarPanel/VeltCommentsSidebarPanel';
var VeltCommentsSidebarWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comments-sidebar-wireframe", __assign({}, remainingProp), children));
};
VeltCommentsSidebarWireframe.CloseButton = VeltCommentsSidebarCloseButton;
VeltCommentsSidebarWireframe.EmptyPlaceholder = VeltCommentsSidebarEmptyPlaceholder;
VeltCommentsSidebarWireframe.Filter = VeltCommentsSidebarFilter;
VeltCommentsSidebarWireframe.Header = VeltCommentsSidebarHeader;
VeltCommentsSidebarWireframe.List = VeltCommentsSidebarList;
VeltCommentsSidebarWireframe.PageModeComposer = VeltCommentsSidebarPageModeComposer;
VeltCommentsSidebarWireframe.Search = VeltCommentsSidebarSearch;
VeltCommentsSidebarWireframe.Status = VeltCommentsSidebarStatus;
VeltCommentsSidebarWireframe.FilterButton = VeltCommentsSidebarFilterButton;
VeltCommentsSidebarWireframe.Skeleton = VeltCommentsSidebarSkeleton;
VeltCommentsSidebarWireframe.Panel = VeltCommentsSidebarPanel;
export default VeltCommentsSidebarWireframe;
